export default "__VITE_ASSET__w6Vp1YWS__"